import "./App.css";
import React from "react";
import { MultiStepForm } from "../components/MultiStepForm";

function App() {
  return (
    <div className="app-shell flex justify-center mx-auto px-4 pt-28 pb-12 md:px-6 md:pt-28 md:pb-20">
      <MultiStepForm />
    </div>
  );
}

export default App;
